import React from "react";
import "./AccountBalance.css";
import { Amount } from "../../types/FinanceData";
import { formatBalance } from "../../utils/formatBalance";

interface Props {
    amount: Amount;
}

export const AccountBalance: React.FC<Props> = ({ amount }) => (
    <div className="container">
        <h2 className="title">Balance</h2>
        <div>{formatBalance(amount.minorUnits)}</div>
    </div>
);
